import { useEffect, useState } from "react";
import "./App.css";
import Home from "./components/Home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import RedirectPage from "./RedirectPage";
import Profile from "./Profile";
import CourseList from "./components/course/CourseList";
import CourseDetail from "./components/course/CourseDetail";
import CourseBuilder from "./components/course/CourseBuilder";
import SessionContent from "./components/course/SessionContent";
import OrganizationList from "./components/organization/OrganizationList";
import OrganizationForm from "./components/organization/OrganizationForm";
import OrganizationDetail from "./components/organization/OrganizationDetail";
import CoursePaymentList from "./components/coursePayment/CoursePaymentList";
import CoursePaymentDetail from "./components/coursePayment/CoursePaymentDetail";
import EnrollmentList from "./components/enrollment/EnrollmentList";
import EnrollmentDetail from "./components/enrollment/EnrollmentDetail";
import EnrollmentCreate from "./components/enrollment/EnrollmentCreate";
import ScheduleList from "./components/schedule/ScheduleList";
import ClassDetail from "./components/schedule/ClassDetail";
import { auth } from "./firebase";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      try {
        if (user) {
          const token = await user.getIdToken();
          localStorage.setItem("@token", token);
          localStorage.setItem("@email", user.email || "");
          setIsLoggedIn(true);
        } else {
          localStorage.removeItem("@token");
          localStorage.removeItem("@email");
          setIsLoggedIn(false);
        }
      } finally {
        setAuthReady(true);
      }
    });
    return unsubscribe;
  }, []);

  if (!authReady) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <div className="spinner-border text-primary" role="status" aria-label="Loading" />
      </div>
    );
  }

  return (
    <div className="container-fluid bg-white min-vh-100">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <RedirectPage
                setIsLoggedIn={setIsLoggedIn}
                isLoggedIn={isLoggedIn}
              />
            }
          />
          <Route
            path="/courses"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <CourseList />
              </Home>
            }
          />
          <Route
            path="/courses/new"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <CourseBuilder />
              </Home>
            }
          />
          <Route
            path="/courses/:courseId/edit"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <CourseBuilder />
              </Home>
            }
          />
          <Route
            path="/courses/:courseId"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <CourseDetail />
              </Home>
            }
          />
          <Route
            path="/courses/:courseId/sessions/:sessionId/content"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <SessionContent />
              </Home>
            }
          />
          <Route
            path="/organizations"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <OrganizationList />
              </Home>
            }
          />
          <Route
            path="/organizations/new"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <OrganizationForm />
              </Home>
            }
          />
          <Route
            path="/organizations/:organizationId/edit"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <OrganizationForm />
              </Home>
            }
          />
          <Route
            path="/organizations/:organizationId"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <OrganizationDetail />
              </Home>
            }
          />
          <Route
            path="/course-payments"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <CoursePaymentList />
              </Home>
            }
          />
          <Route
            path="/course-payments/:paymentId"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}>
                <CoursePaymentDetail />
              </Home>
            }
          />
          <Route
            path="/course-enrollments"
            element={<Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}><EnrollmentList /></Home>}
          />
          <Route
            path="/course-enrollments/new"
            element={<Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}><EnrollmentCreate /></Home>}
          />
          <Route
            path="/course-enrollments/:enrollmentId"
            element={<Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}><EnrollmentDetail /></Home>}
          />
          <Route path="/schedule/classes/:classId" element={<Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}><ClassDetail /></Home>} />
          <Route path="/schedule" element={<Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn}><ScheduleList /></Home>} />
          <Route
            path="/:resource"
            element={
              <Home setIsLoggedIn={setIsLoggedIn} isLoggedIn={isLoggedIn} />
            }
          />
          <Route
            path="/profile"
            element={<Profile isLoggedIn={isLoggedIn} />}
          />
          <Route path="*" Component={ErrorPage} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
